/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { brtControllerCreate } from '../fn/brt-shipments/brt-controller-create';
import { BrtControllerCreate$Params } from '../fn/brt-shipments/brt-controller-create';
import { brtControllerDeleteShipment } from '../fn/brt-shipments/brt-controller-delete-shipment';
import { BrtControllerDeleteShipment$Params } from '../fn/brt-shipments/brt-controller-delete-shipment';
import { brtControllerTrackShipment } from '../fn/brt-shipments/brt-controller-track-shipment';
import { BrtControllerTrackShipment$Params } from '../fn/brt-shipments/brt-controller-track-shipment';
import { CreateShipmentResponse } from '../models/create-shipment-response';
import { DeleteShipmentResponseDto } from '../models/delete-shipment-response-dto';
import { TrackShipmentResponseDto } from '../models/track-shipment-response-dto';

@Injectable({ providedIn: 'root' })
export class BrtShipmentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `brtControllerCreate()` */
  static readonly BrtControllerCreatePath = '/couriers/brt/create-shipment';

  /**
   * Create a new BRT shipment.
   *
   * Creates a new shipment with BRT courier service and returns tracking information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `brtControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  brtControllerCreate$Response(params: BrtControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateShipmentResponse>> {
    return brtControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new BRT shipment.
   *
   * Creates a new shipment with BRT courier service and returns tracking information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `brtControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  brtControllerCreate(params: BrtControllerCreate$Params, context?: HttpContext): Observable<CreateShipmentResponse> {
    return this.brtControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateShipmentResponse>): CreateShipmentResponse => r.body)
    );
  }

  /** Path part for operation `brtControllerDeleteShipment()` */
  static readonly BrtControllerDeleteShipmentPath = '/couriers/brt/delete-shipment';

  /**
   * Delete a BRT shipment.
   *
   * Deletes a shipment with BRT courier service
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `brtControllerDeleteShipment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  brtControllerDeleteShipment$Response(params: BrtControllerDeleteShipment$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteShipmentResponseDto>> {
    return brtControllerDeleteShipment(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a BRT shipment.
   *
   * Deletes a shipment with BRT courier service
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `brtControllerDeleteShipment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  brtControllerDeleteShipment(params: BrtControllerDeleteShipment$Params, context?: HttpContext): Observable<DeleteShipmentResponseDto> {
    return this.brtControllerDeleteShipment$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteShipmentResponseDto>): DeleteShipmentResponseDto => r.body)
    );
  }

  /** Path part for operation `brtControllerTrackShipment()` */
  static readonly BrtControllerTrackShipmentPath = '/couriers/brt/track-shipment/{parcelID}';

  /**
   * Track a BRT shipment.
   *
   * Tracks a shipment with BRT courier service
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `brtControllerTrackShipment()` instead.
   *
   * This method doesn't expect any request body.
   */
  brtControllerTrackShipment$Response(params: BrtControllerTrackShipment$Params, context?: HttpContext): Observable<StrictHttpResponse<TrackShipmentResponseDto>> {
    return brtControllerTrackShipment(this.http, this.rootUrl, params, context);
  }

  /**
   * Track a BRT shipment.
   *
   * Tracks a shipment with BRT courier service
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `brtControllerTrackShipment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  brtControllerTrackShipment(params: BrtControllerTrackShipment$Params, context?: HttpContext): Observable<TrackShipmentResponseDto> {
    return this.brtControllerTrackShipment$Response(params, context).pipe(
      map((r: StrictHttpResponse<TrackShipmentResponseDto>): TrackShipmentResponseDto => r.body)
    );
  }

}
